import { Component, OnInit } from '@angular/core';

import { AbstractPropertyEditorBase } from '../../types/property-editor.types';

@Component({
  selector: 'df-width-editor',
  templateUrl: './width-editor.component.html',
  styleUrls: ['./width-editor.component.css']
})
export class WidthEditorComponent extends AbstractPropertyEditorBase implements OnInit {
  settings: any = {};
  minValue = 0;
  maxValue = 12;

  isAdjust: boolean = false;

  constructor() {
    super();
  }

  ngOnInit() {
    // å¦ææ²¡ævalue åç¨ä¼ è¿æ¥çé»è®¤å¼ï¼é»è®¤å¼ä¸º0 ä¹å¯ä»¥ 0è¡¨ç¤ºä¸è®¾ç½®ï¼å¦åé»è®¤å¼æ¯12 è¡¨ç¤ºå¡«æ»¡æ´è¡
    if (isNaN(this.value)) {
      let val = this.settings.defaultValue;
      if (!isNaN(this.settings.defaultValue)) {
        val = this.settings.defaultValue;
      } else {
        val = 12;
      }
      setTimeout(() => {
        this.value = val;
      }, 0);
    }
  }
}
